import { styled, Theme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

type ContainerProps = {
  isAI: boolean;
  messageIndex: number;
};

export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI" && prop !== "messageIndex",
})(({ isAI, messageIndex }: ContainerProps) => ({
  display: "flex",
  flexDirection: isAI ? "row" : "row-reverse",
  alignItems: "flex-start",
  width: "100%",
  marginTop: messageIndex === 0 ? "auto" : 0,
}));

type AvatarContainerProps = {
  isAI: boolean;
};

export const AvatarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ theme, isAI }: AvatarContainerProps & { theme: Theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "36px",
  height: "36px",
  borderRadius: "4px",
  backgroundColor: isAI ? theme.palette.primary.main : "#555555",
  flexShrink: 0,
  marginTop: "2px",
}));

type MessageContainerProps = {
  theme: Theme;
  isAI: boolean;
};

export const MessageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ theme, isAI }: MessageContainerProps) => ({
  backgroundColor: isAI
    ? theme.palette.background.default
    : theme.palette.inputBackground,
  borderRadius: "12px",
  border: isAI ? `1px solid ${theme.palette.divider}` : "none",
  textAlign: `${isAI ? "left" : "right"}`,
  padding: "12px 16px",
  maxWidth: "75%",
  display: "flex",
}));

type MessageBoxProps = {
  isAI: boolean;
};

export const MessageBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ theme, isAI }: MessageBoxProps & { theme: Theme }) => ({
  color: isAI ? theme.palette.text.primary : theme.palette.text.secondary,
  fontSize: "14px",
  lineHeight: 1.5,
  "> p": {
    margin: 0,
  },
}));

export const MessageMeta = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAI",
})(({ isAI }: { isAI: boolean }) => ({
  display: "flex",
  flexDirection: isAI ? "row" : "row-reverse",
  alignItems: "center",
  gap: "4px",
  marginTop: "4px",
  paddingLeft: isAI ? "46px" : "0",
  paddingRight: isAI ? "0" : "46px",
}));

export const Timestamp = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: "11px",
}));

export const CheckMark = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.tertiary,
  fontSize: "11px",
}));
